<template>
  <div id="content" class="com-con" style="margin-top: 105px">
    <div class="wrapper">
      <div id="un-lobby" class="clearfix" style="padding-top: 45px">
        <aside>
          <ul id="layout-aside" class="sidebar">
            <li :class="type == 0 ? 'about active' : 'about'" @click="changType(0)" id="SYWA_GYWM_KEY">
              <a
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('foot.about')}}</font></font
                ><span
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">about us</font></font></span
                >
              </a>
            </li>

            <li :class="type == 1 ? 'contact active' : 'contact'" @click="changType(1)" id="SYWA_LLWM_KEY">
              <a
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('foot.contactus')}}</font></font
                ><span
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">contact us'</font></font></span
                >
              </a>
            </li>

            <li :class="type == 2 ? 'partner active' : 'partner'" @click="changType(2)" id="SYWA_HZHB_KEY">
              <a
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('foot.Agents')}}</font></font
                ><span
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">Agent to join</font></font></span
                >
              </a>
            </li>

            <li :class="type == 3 ? 'withdraw active' : 'withdraw'" @click="changType(3)" id="SYWA_MFSM_KEY">
              <a
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('foot.Disclaimer')}}</font></font
                ><span
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">Disclaimer</font></font></span
                >
              </a>
            </li>

            <li :class="type == 4 ? 'withdraw active' : 'withdraw'" @click="changType(4)" id="SYWA_YSZC_KEY">
              <a
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('foot.Privacy')}}</font></font
                ><span
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">Privacy Policy</font></font></span
                >
              </a>
            </li>

            <li :class="type == 5 ? 'faq active' : 'faq'" @click="changType(5)">
              <a
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('foot.common')}}</font></font
                ><span
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">common problem</font></font></span
                ></a
              >
            </li>

            <li :class="type == 6 ? 'deposit active' : 'deposit'" @click="changType(6)" id="SYWA_BCZR_KEY">
              <a
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('foot.game')}}</font></font
                ><span
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">Gaming Responsibility</font></font></span
                >
              </a>
            </li>
          </ul>
        </aside>

        <article id="articles" v-if="type == 0">
          <div data-v-5f371c9e="" class="right_content about_us active">
            <div data-v-5f371c9e="" class="right_content_body">
              <p data-v-5f371c9e="" class="right_content_title"></p>
              <div v-html="dataBox7.content"></div>
            </div>
          </div>
        </article>
        <article id="articles" v-if="type == 1">
          <div data-v-5f371c9e="" class="right_content about_us active">
            <div data-v-5f371c9e="" class="right_content_body">
              <p data-v-5f371c9e="" class="right_content_title"></p>
              <div v-html="dataBox4.content"></div>
            </div>
          </div>
          <div data-v-5f371c9e="" class="contact_list" style="margin-top: 30px">
            <a data-v-5f371c9e="" href="javascript:;" target="_self" class="contact_content" @click="$parent.openKefu"
              ><div data-v-5f371c9e="" class="icon_circle_card"><img data-v-5f371c9e="" alt="" src="/static/image/icon_cs_hover.png" class="blue" /></div>
              <div data-v-5f371c9e="" class="cs_text">{{$t('foot.kefgu')}} </div></a
            >
          </div>
        </article>

        <article id="articles" v-if="type == 2">
          <div data-v-5f371c9e="" class="right_content about_us active">
            <div data-v-5f371c9e="" class="right_content_body">
              <p data-v-5f371c9e="" class="right_content_title"></p>
              <div v-html="dataBox5.content"></div>
            </div>
          </div>
          <div style="width: 600px; padding-top: 40px" v-if="$store.state.userInfo.isagent == 0">
            <el-form label-width="80px">
              <el-form-item :label="$t('foot.actual')">
                <el-input :value="$store.state.userInfo.realname" disabled :placeholder="$t('foot.real')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('foot.number')">
                <el-input v-model="info.mobile" :placeholder="$t('foot.enterqq')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('foot.Reason')">
                <el-input type="textarea" v-model="info.apply_info" :placeholder="$t('foot.enter')"></el-input>
              </el-form-item>
              <el-form-item style="display: flex; justify-content: center">
                <el-button v-if="$store.state.token" type="primary" @click="shenqing">{{$t('foot.Applications')}}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </article>

        <article id="articles" v-if="type == 3">
          <div data-v-5f371c9e="" class="right_content about_us active">
            <div data-v-5f371c9e="" class="right_content_body">
              <p data-v-5f371c9e="" class="right_content_title"></p>
              <div v-html="dataBox3.content"></div>
            </div>
          </div>
        </article>
        <article id="articles" v-if="type == 4">
          <div data-v-5f371c9e="" class="right_content about_us active">
            <div data-v-5f371c9e="" class="right_content_body">
              <p data-v-5f371c9e="" class="right_content_title"></p>
              <div v-html="dataBox2.content"></div>
            </div>
          </div>
        </article>

        <article id="articles" v-if="type == 5">
          <div data-v-5f371c9e="" class="right_content about_us active">
            <div data-v-5f371c9e="" class="right_content_body">
              <p data-v-5f371c9e="" class="right_content_title"></p>
              <div v-html="dataBox1.content"></div>
            </div>
          </div>
        </article>
        <article id="articles" v-if="type == 6">
          <div data-v-5f371c9e="" class="right_content about_us active">
            <div data-v-5f371c9e="" class="right_content_body">
              <p data-v-5f371c9e="" class="right_content_title"></p>
              <div v-html="dataBox8.content"></div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'footAll',
  data() {
    // 1常见问题  2隐私政策  3免责说明  4联系我们  5代理加盟  7关于我们 8博彩责任  
    return { type: 0, info: {}, dataBox1: {}, dataBox2: {}, dataBox3: {}, dataBox4: {}, dataBox5: {},  dataBox7: {}, dataBox8: {} };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }
    let arr = [1, 2, 3, 4, 5, 7, 8];
    arr.forEach(el => {
      that.getAllCont(el);
    });
  },
  methods: {
    getAllCont(type) {
      let that = this;
      that.showLoading();

      that.$apiFun
        .post('/api/article', { type })
        .then(res => {
          let name = 'dataBox' + type;
          that[name] = res.data;
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },

    changType(type) {
      let that = this;

      that.type = type;
    },
    shenqing() {
      let that = this;
      that.birthday = $('.ant-picker-input').html();
      let info = that.info;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(info.mobile)) {
        that.showTost(0, that.$t('foot.correct'));
        return;
      }

      if (!info.apply_info) {
        that.showTost(0, that.$t('foot.enters'));
        return;
      }

      that.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
          that.showTost(1, res.message);
          that.hideLoading();
          that.info = {};
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        let query = this.$route.query;
        if (query) {
          if (query.type) {
            if (that.type != query.type) {
              that.type = query.type * 1;
            }
          }
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
#layout-aside .active a {
  color: #ffd053 !important;
}
#layout-aside a {
  cursor: pointer;
}
#layout-aside.sidebar li.active:before {
  background-position-x: -84px;
}
.contact_content[data-v-5f371c9e] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;

  border: #b4b4b4 solid 1px;
  border-radius: 3px;

  padding: 10px 20px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 48%;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/footAll.vue